// A notification about ONE item deep-links here. The item is the entity that
// was routed, so the link carries the item id and this resolves it to the
// separation it belongs to — landing the person on their own filtered list
// rather than on a record most of them may not read.
import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { supabase } from '../../shared/supabase';
import { Card, Skeleton } from '../../shared/components';

export default function SeparationItemLink() {
  const { itemId } = useParams<{ itemId: string }>();
  const [sepId, setSepId] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    if (!itemId) return;
    void (async () => {
      const { data } = await supabase
        .from('separation_checklist_items')
        .select('separation_id')
        .eq('item_id', itemId)
        .maybeSingle();
      setSepId((data as { separation_id: string } | null)?.separation_id ?? null);
    })();
  }, [itemId]);

  if (sepId === undefined) return <Skeleton className="m-6 h-24" />;
  if (sepId === null) {
    return (
      <div className="mx-auto max-w-2xl p-6">
        <Card className="p-6 text-sm text-tcs-text-secondary">
          That checklist item is no longer assigned to you, or it has been removed.
        </Card>
      </div>
    );
  }
  return <Navigate to={`/people/separations/${sepId}`} replace />;
}
